import { axiosInstance as request } from '@api/rest.service'

const api = '/products'

/**
 * @description GET /products/{id}/subscriptions
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCTS_SUBSCRIPTIONS = id => request.get(`${api}/${id}/subscriptions`)

/**
 * @description GET /products/{id}/title-lists
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCTS_TITLE_LISTS = id => request.get(`${api}/${id}/title-lists`)

/**
 * @description GET /products/{id}/subject-categories
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCTS_SUBJECT_CATEGORIES = id => request.get(`${api}/${id}/subject-categories`)

/**
 * @description POST /products/{id}/subject-categories/{id}
 * @returns {AxiosPromise<any>}
 */
export const ADD_SUBJECT_CATEGORY_TO_PRODUCT = (prodId, subjId) =>
  request.post(`${api}/${prodId}/subject-categories/${subjId}`)

/**
 * @description DELETE /products/{id}/subject-categories/{id}
 * @returns {AxiosPromise<any>}
 */
export const REMOVE_SUBJECT_CATEGORY_FROM_PRODUCT = (prodId, subjId) =>
  request.delete(`${api}/${prodId}/subject-categories/${subjId}`)

/**
 * @description GET /products
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCTS = () => request.get(api)

/**
 * @description GET /products?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_PRODUCTS = params => request.get(`${api}?paginated=true`, { params })

/**
 * @description GET /products/create
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCTS_CREATE = () => request.get(`${api}/create`)

/**
 * @description POST /products
 * @returns {AxiosPromise<any>}
 */
export const CREATE_PRODUCT = payload => request.post(api, payload)

/**
 * @description GET /products/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCT = id => request.get(`${api}/${id}`)

/**
 * @description PUT /products/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_PRODUCT = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /products/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_PRODUCT_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /products/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_PRODUCT = id => request.delete(`${api}/${id}`)
